(() => {
  const SEL = '[data-rd-pu]';
  const init = (root) => {
    if (!root || root.dataset.puInit === '1') return;
    root.dataset.puInit = '1';
    const currency = root.dataset.currency || 'GBP';
    const money = (c) => {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency }).format(c / 100); }
      catch (e) { return '£' + (c / 100).toFixed(2); }
    };
    const setCount = (n) => {
      document.querySelectorAll('[data-cart-count]').forEach((t) => { t.textContent = String(n); });
      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        const v = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
        if (v) v.textContent = String(n);
        bubble.classList.toggle('hidden', n === 0);
      });
    };
    const addItems = async (items) => {
      const body = { items };
      const cartUi = document.querySelector('cart-drawer, cart-notification');
      if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
        const ids = cartUi.getSectionsToRender().map((e) => e.id).filter(Boolean);
        if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
      }
      const res = await fetch(root.dataset.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
      let data = {};
      try { data = await res.json(); } catch (e) { data = {}; }
      if (!res.ok) throw new Error(data.description || data.message || "Couldn't add that. Try again.");
      if (cartUi && typeof cartUi.renderContents === 'function' && data.sections) cartUi.renderContents(data);
      try {
        const cr = await fetch(root.dataset.cartUrl, { headers: { Accept: 'application/json' } });
        if (cr.ok) {
          const cart = await cr.json();
          setCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'pdp-upsells', cart, item: data } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'pdp-upsells', cart, item: data } }));
        }
      } catch (e) { /* ignore */ }
    };

    root.querySelectorAll('[data-pu-rail]').forEach((rail) => {
      const track = rail.querySelector('[data-pu-track]');
      const step = () => Math.max(220, Math.round(track.clientWidth * 0.8));
      rail.querySelector('[data-pu-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      rail.querySelector('[data-pu-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    });

    root.querySelectorAll('[data-pu-card]').forEach((card) => {
      let variants = [];
      try { variants = JSON.parse(card.querySelector('[data-pu-variants]')?.textContent || '[]'); } catch (e) { variants = []; }
      const select = card.querySelector('[data-pu-select]');
      const priceEl = card.querySelector('[data-pu-price]');
      const btn = card.querySelector('[data-pu-add]');
      const label = btn.firstElementChild;
      select?.addEventListener('change', () => {
        const v = variants.find((x) => String(x.id) === select.value);
        if (!v) return;
        btn.dataset.variant = v.id;
        priceEl.textContent = money(v.price);
        btn.disabled = !v.a;
      });
      btn.addEventListener('click', async () => {
        if (btn.disabled) return;
        btn.disabled = true;
        label.textContent = 'Adding...';
        try {
          await addItems([{ id: Number(btn.dataset.variant), quantity: 1 }]);
          label.textContent = 'Added';
          btn.classList.add('is-done');
          setTimeout(() => { btn.classList.remove('is-done'); label.textContent = 'Add'; btn.disabled = false; }, 1800);
        } catch (err) {
          label.textContent = 'Try again';
          setTimeout(() => { label.textContent = 'Add'; btn.disabled = false; }, 1800);
        }
      });
    });

    const box = root.querySelector('[data-pu-box]');
    const poolEl = root.querySelector('[data-pu-pool]');
    if (box && poolEl) {
      let pool = [];
      try { pool = JSON.parse(poolEl.textContent || '[]'); } catch (e) { pool = []; }
      if (pool.length < 3) { box.remove(); return; }
      const reveal = box.querySelector('[data-pu-reveal]');
      const list = box.querySelector('[data-pu-list]');
      const totalEl = box.querySelector('[data-pu-total]');
      const statusEl = box.querySelector('[data-pu-status]');
      const addAll = box.querySelector('[data-pu-addall]');
      const pills = [...box.querySelectorAll('[data-pu-n]')];
      let n = 3;
      let picks = [];
      const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const draw = () => {
        const copy = pool.slice();
        for (let i = copy.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [copy[i], copy[j]] = [copy[j], copy[i]]; }
        picks = copy.slice(0, Math.min(n, copy.length));
        list.innerHTML = picks.map((p) => '<li><a href="' + esc(p.u) + '">' + esc(p.t) + '</a><span>' + money(p.p) + '</span></li>').join('');
        totalEl.textContent = money(picks.reduce((s, p) => s + p.p, 0));
        reveal.hidden = false;
        statusEl.textContent = '';
        addAll.disabled = false;
        addAll.classList.remove('is-done');
        addAll.firstElementChild.textContent = 'Add all to bowl';
      };
      pills.forEach((pill) => pill.addEventListener('click', () => {
        n = Number(pill.dataset.puN);
        pills.forEach((x) => x.setAttribute('aria-pressed', x === pill ? 'true' : 'false'));
        if (!reveal.hidden) draw();
      }));
      box.querySelector('[data-pu-go]')?.addEventListener('click', draw);
      box.querySelector('[data-pu-shuffle]')?.addEventListener('click', draw);
      addAll.addEventListener('click', async () => {
        if (addAll.disabled || !picks.length) return;
        addAll.disabled = true;
        addAll.firstElementChild.textContent = 'Adding...';
        statusEl.textContent = '';
        try {
          await addItems(picks.map((p) => ({ id: p.id, quantity: 1, properties: { _box: 'Mix and match' } })));
          addAll.firstElementChild.textContent = 'Added to bowl';
          addAll.classList.add('is-done');
          setTimeout(() => { addAll.disabled = false; }, 1800);
        } catch (err) {
          addAll.disabled = false;
          addAll.firstElementChild.textContent = 'Add all to bowl';
          statusEl.textContent = err.message;
        }
      });
    }
  };

  document.querySelectorAll(SEL).forEach(init);
  if (!window.__rdPuEvents) {
    window.__rdPuEvents = true;
    document.addEventListener('shopify:section:load', (e) => init(e.target.matches?.(SEL) ? e.target : e.target.querySelector?.(SEL)));
  }
})();